namespace $ {

	export class $bog_max_category extends $giper_baza_dict.with({
		Title: $giper_baza_atom_text,
		Owner: $giper_baza_atom_text,
		Scope: $giper_baza_atom_text,
		React: $giper_baza_atom_real,
		Fix: $giper_baza_atom_real,
		Basis: $giper_baza_atom_text,
	}) {}

}
